export default {
  container: {
    opacity: '0',
    animation: '0.6s fadeIn ease-in forwards'
  },
  table: {
    '& th': {
      textAlign: 'left',
      '& span': {
        height: '16px'
      }
    },
    '& td span': {
      height: '16px'
    },
    '& tr:hover td': {
      backgroundColor: 'transparent'
    }
  },
  all: {
    width: '25px'
  },
  allCell: {
    width: '60px',
    textAlign: 'center !important'
  },
  receivedCell: {
    width: '115px'
  },
  received: {
    width: '66px'
  },
  fromCell: {
    width: '20%'
  },
  from: {
    width: '42px'
  },
  titleCell: {
    width: '20%'
  },
  title: {
    width: '38px'
  },
  loCell: {
    width: '40%'
  },
  lo: {
    width: '135px'
  },
  contextCell: {
    width: '60px'
  },
  center: {
    textAlign: 'center !important'
  },
  bulkAction: {
    display: 'block',
    height: '40px !important',
    width: '93px',
    borderRadius: '4px'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}
